import { render, staticRenderFns } from "./user_shipper_creat.vue?vue&type=template&id=79f3fe14&scoped=true&"
import script from "./user_shipper_creat.vue?vue&type=script&lang=js&"
export * from "./user_shipper_creat.vue?vue&type=script&lang=js&"
import style0 from "./user_shipper_creat.vue?vue&type=style&index=0&id=79f3fe14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f3fe14",
  null
  
)

export default component.exports